/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
// @ts-ignore
import {
  RetorikAgent,
  RetorikWidget,
  addDetailedAttachmentTrigger
} from "@davi-ai/retorik-framework";
import type {
  AddressData,
  WidgetConfiguration,
  Configuration,
} from "@davi-ai/retorik-framework";
import { tenants } from "./data";
import React, { useEffect } from "react";
import { setupIonicReact } from '@ionic/react'
import { botEventHandler } from "./components/CustomBotEventHandler";
import { actionData } from "./article_template";
setupIonicReact()

const widgetMode = false;

const addressData: AddressData =tenants.MVEB;

const widgetConfig: WidgetConfiguration = 
  {
    button: {
      text: {
        color: '#fff',
        content:'BESOIN D\'AIDE'
      },
      image: {
        url: 'images/lea@2x.png',
        height:"3rem",
        marginY:true
      },
      border: {
        color: '#fff'
      },
      background:{
        color:"#0082CA"
      }
    },
    large: {}
  }

const ArticleTemplate = (data) =>{
    useEffect(() => {
      console.log('data : ', data)
    }, [data])

    return (
      <div
        className={'ArticleContent'}
        style={{
          width: '85%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: '3rem',
          marginLeft: '3rem'
        }}
      >
        <div style={{
          fontSize: '1.8rem',
          fontWeight: 'bold',
          lineHeight: '1.5em'
        }}
        >{data.props.Thing.Name.Text}</div>

        <div 
          style={{
            marginTop: '2rem',
            paddingBottom: '5rem'
          }}
          dangerouslySetInnerHTML={{__html: data.props.Thing.HTML.Html}}></div>
      </div>
    )
}

const App = () => {
  const defaultConfig: Configuration = {
    position: {
      searchForLocation: false,
    }
 };

  const props = {
    addressData: addressData,
    widgetConfig,
    config: defaultConfig
  };

    useEffect(() => {
      addDetailedAttachmentTrigger({
        ...actionData,
        linkedComponent: ArticleTemplate
      })
    }, [])

    console.log("actionData : ", actionData);
  

  return widgetMode ? (
    <RetorikWidget {...props} externalEventHandler={botEventHandler}/>
  ) : (
    <RetorikAgent {...props} externalEventHandler={botEventHandler} />
  );
};

export default App;